export const getDefaultValues = (contentDetails, SocialManagerContentSocialManagerAccountID = 0) => ({
  SocialManagerContentSocialManagerAccountID,
  SocialManagerContentSocialManagerContentTypeID: contentDetails?.SocialManagerContentSocialManagerContentTypeID || 0,
  SocialManagerContentSocialManagerContentStatusTypeID: contentDetails?.SocialManagerContentSocialManagerContentStatusTypeID || 0,
  SocialManagerContentContent: contentDetails?.SocialManagerContentContent || '',
  SocialManagerContentFile: contentDetails?.SocialManagerContentFile || '',
  SocialManagerContentFileName: contentDetails?.SocialManagerContentFileName || '',
});
